import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowLeftSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor" d="M6.5 13.5H22m-15.5 0L10 17m-3.5-3.5L10 10"></path>
    </svg>
)

const ArrowLeftKeyboard: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowLeftSvg}
    </SvgIcon>
)

export default ArrowLeftKeyboard